






























































import {
	defineComponent,
} from '@vue/composition-api';
import { Routes } from '@front-app/constants/routes';
import TrHomeIcon from '@front-app/components/icons/TrLogo.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import HeaderLink from './HeaderLink.vue';

export default defineComponent({
	components: {
		HeaderLink,
		TrHomeIcon,
		FontAwesomeIcon,
	},
	props: {
		excludeInactiveTabs: {
			type: Boolean,
		},
		hoveredItem: {
			type: String,
			default: '',
		},
		selectedItem: {
			type: String,
			default: '',
		},
	},
	setup() {
		return {
			Routes: {
				HOME: Routes.HOME,
				GROUPS: Routes.GROUPS,
				EVENTS: Routes.EVENTS,
			},
		};
	},
});
